import React from 'react';
import classNames from 'classnames';
import { Duration } from 'luxon';

interface CurrentStatusProps {
  running: boolean;
  onBreak: boolean;
  value: Duration;
}

export default function CurrentStatus({ running, onBreak, value }: CurrentStatusProps) {
  // Determine label
  const label = React.useMemo(() => {
    if (onBreak) return 'On Break';
    if (running) return 'Clocked In';
    return 'Clocked Out';
  }, [running, onBreak]);

  // Calculate percentage of minute
  const seconds = React.useMemo(() => (
    ((((value?.toMillis() || 0) / 1000) % 60) / 60) * 100
  ), [value]);

  // Determine progress colors
  const [foreground, background] = React.useMemo(() => {
    if (onBreak) return ['--s-surface-warning-default', '--s-surface-warning-subdued'];
    return ['--action-primary-default', '--surface-highlight-default'];
  }, [onBreak]);

  // Styling
  const progressBackground = React.useMemo(() => (
    `conic-gradient(var(${foreground}) ${seconds * 3.6}deg, var(${background}) 0deg`
  ), [foreground, background, seconds]);

  return (
    <div className="mb-16">
      <div className={classNames('status-progress', { 'on-break': onBreak })} style={{ background: progressBackground }}>
        <div className="status-progress-inner">
          <div className="status-progress-time">{value?.toFormat('hh:mm:ss') || '00:00:00'}</div>
          <div className="status-progress-label text-muted">{label}</div>
        </div>
      </div>
    </div>
  );
}
